let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("dSgGr"), load("c5uOY"), load("6wr18"), load("37ldp"), load("ffEVr"), load("hhss7"), load("aDFb6")]).then(() => parcelRequire('2zBDm'));